// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentMethods_root__1LXU9","title":"PaymentMethods_title__6XCVI","cardsContainer":"PaymentMethods_cardsContainer__Vje6h"};